class LollipopPetal {
  constructor() {
    this.index = 0;
    this.pathogenicityDetails = [];
    this.lollipop = null;
    this.containedDbs = new Set();
  }

  addVariant(pathogenicityDetails) {
    this.pathoIndex = pathogenicityDetails.pathoIndex;
    this.codingImpactIndex = pathogenicityDetails.codingImpactIndex;
    this.codingImpactColorIndex = pathogenicityDetails.codingImpactColorIndex;
    this.pathogenicityDetails.push(pathogenicityDetails);
    this.containedDbs.add(pathogenicityDetails?.sourceIndex);
  }

  getVariantId() {
    return this.pathogenicityDetails[0].variant.id;
  }

  hasAnyDb(dbSet) {
    return dbSet.find((x) => this.containedDbs.has(x));
  }

  addToLollipop(lollipop) {
    if (this.lollipop) return;
    this.index = lollipop.petalSize || 0;
    this.lollipop = lollipop;
    lollipop.addPetal(this);
  }

  get region() {
    return this.pathogenicityDetails[0]?.region;
  }

  get variant() {
    return this.pathogenicityDetails[0]?.variant;
  }
}

export default LollipopPetal;
